import 'css-chunksrc/client/pages/personalSpacePage/synthesis/tasksLoader/styles.scss';export default {
  "task": "_task_1bddj_1",
  "nameBox": "_nameBox_1bddj_8",
  "name": "_name_1bddj_8",
  "statusBox": "_statusBox_1bddj_17",
  "status": "_status_1bddj_17",
  "endDateBox": "_endDateBox_1bddj_26",
  "endDate": "_endDate_1bddj_26"
};